/* eslint-disable prettier/prettier */

import React from 'react';
import './Content.css';

const Content = () => (
    <div className="header__content">
        <h1>Everyone should watch at least one good movie in their life.</h1>
        <h2>This is a movie DB site</h2>
        <p>
            <samp>
            Here you can search your favorite movie And you can see the details about this movie. Also you can see some of the most popular movies.
            </samp>
        </p>
    </div>
);

export default Content;
